/*Style input fields */
export const inputStyle =
{
  height: "30px",
  borderRadius: "12px",
  border: "none",
  backgroundColor: "var(--blue)",
  boxShadow: "none",
  hoverBackgroundColor: "var(--lightblue)",
  color: "var(--almostblack)",
  fontSize: "calc(8px + 0.7vw)",
  fontFamily: "var(--font2)",
  iconColor: "var(--almostblack)",
  lineColor: "var(--almostblack)",
  placeholderColor: "var(--darkgray)",
  clearIconMargin: '3px 5px 0 0',
}; 

export const scrollStyle = {
  background: "var(--faintpurple)",
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  padding: "0.5%"
};


